import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let cached: SupabaseClient | null = null;

export function getSupabaseClient() {
	if (cached) return cached;
	const url = (process.env.NEXT_PUBLIC_SUPABASE_URL || process.env.SUPABASE_URL) as string;
	const anon = (process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY) as string;
	if (!url || !anon) throw new Error('Supabase env vars missing');
	cached = createClient(url, anon, { auth: { persistSession: true, autoRefreshToken: true } });
	return cached;
}
